export default __webpack_public_path__ + "static/media/not-support-voice.7f08a19a.svg";